<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    chartTitle: {
      type: String,
      default: '一步位来'
    },
    width: {
      type: String,
      default: '1.5625rem'
    },
    height: {
      type: String,
      default: '1.5625rem'
    },
    chartData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
       
    },
    setOptions (expectedData) {
      console.log(this.chartTitle);
      this.chart.setOption({
        title: {

          x:"right",    // 'left' | 'right' | 'center' | '100px'
	        y:"4%",     // 'top' | 'bottom' | 'center' | '100px'
          text: this.chartTitle,
          left: 'center',
          top: 0,
          textStyle: {
            color: '#ffffff',
            fontWeight: "normal",
            fontFamily: "sans-serif", // 主标题文字的字体系列。
      fontSize:"0.0833rem",// 字体大小
      lineHeight: "3rem", // 行高
      textBorderColor: "#3274a6", // 文字本身的描边颜色。
      textBorderWidth:3, // 文字本身的描边宽度。
      textShadowColor: "#232584", // 文字本身的阴影颜色。
      textShadowBlur: 3, // 文字本身的阴影长度。
      textShadowOffsetX: 3, // 文字本身的阴影 X 偏移。
      textShadowOffsetY: 3, //  文字本身的阴影 Y 偏移
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        color: ['#fe6665', '#3189dc', '#d48265', '#eeb233', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
        series: [
          {
            type: 'pie',
            pointer: {
                width:3,//指针的宽度
                length:"80%", //指针长度，按照半圆半径的百分比
                shadowColor : '#ccc', //默认透明
                shadowBlur: 5
            },
            axisLabel: {
                show: true,
                    textStyle: {
                    color: '#333333',  //更改坐标轴文字颜色
                    fontSize : 10   //更改坐标轴文字大小
                }
            },
            radius: ['20%', '80%'],
            label: {
              normal: {
                formatter: '{b} : {c}',
                position: 'inside'
              }
            },
            center: 'center',
            data: expectedData,
            animationEasing: 'cubicInOut',
            animationDuration: 2600
          }
        ]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index/PieChart.vue